import { render } from "./AddResiliation.vue?vue&type=template&id=15b47604&ts=true"
import script from "./AddResiliation.vue?vue&type=script&lang=ts"
export * from "./AddResiliation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__